import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';
import { hexToRgba } from 'webapp/utils/color';

import CommonDisabledOverlayComponent from 'webapp/components/common/disabled-overlay';

interface Args {
	feature: BillingFeature;
	bgColor: string;
}

export default class BlockContentCommonDisabledOverlayComponent extends CommonDisabledOverlayComponent<Args> {
	@service('constants') declare constantsService: Service.Constants;

	get feature() {
		return this.args.feature;
	}

	override get trackingOrigin() {
		return this.feature === BillingFeature.GENERATIVE_AI
			? 'generative_ai_block'
			: super.trackingOrigin;
	}

	get overlayStyle() {
		let style = '';

		// 95% overlay of the darker color
		const colorsConfig = Array.from(this.constantsService.boardColors || []),
			fromConfig = colorsConfig.find((item) => item.hex === this.args.bgColor),
			darkerColor = fromConfig?.bottom;
		if (darkerColor) {
			style = `background-color:${hexToRgba(darkerColor, 0.95)}`;
		}

		return htmlSafe(style);
	}
}
